import BaseAPI from "./api";
import env from "../environment";
import { AppConstants } from "../constants/AppConstants";

const API = BaseAPI?.axiosInstance;

export const getUsers = async (
  filters?: string,
  page: number = 1,
  size: number = 10,
  sorters: string = ""
) => {
  const headers = { ...AppConstants.GLOBAL_HEADERS };
  let uri = `/${env.userManagementPath}/users?${AppConstants.QUERY_PARAM_PAGE}=${page}&${AppConstants.QUERY_PARAM_SIZE}=${size}`;
  if (filters) {
    uri += `&${AppConstants.QUERY_PARAM_FILTERS}=${filters}`;
  }
  if (sorters) {
    uri += `${sorters}`;
  }
  return await API.get(uri, { headers }).then((res: any) => res);
};

export const getUserProfile = async () => {
  const headers = { ...AppConstants.GLOBAL_HEADERS };
  let uri = `/${env.userManagementPath}/profile`;
  return await API.get(uri, { headers }).then((res: any) => res);
};
